export function ceilWithPrecision(value: number) {
  if (Math.abs(value) < 1) {
    const precision = 0.1;
    return Math.ceil(value / precision) * precision;
  }

  return Math.ceil(value);
}

export function floorWithPrecision(value: number) {
  if (Math.abs(value) < 1) {
    const precision = 0.1;
    return Math.floor(value / precision) * precision;
  }

  return Math.floor(value);
}
